import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=a944ab3a&scoped=true"
import script from "./DropdownUser.vue?vue&type=script&lang=ts"
export * from "./DropdownUser.vue?vue&type=script&lang=ts"
import style0 from "./DropdownUser.vue?vue&type=style&index=0&id=a944ab3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a944ab3a",
  null
  
)

export default component.exports